<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="شكر-وتقدير">
<h1><span dir="rtl">شكر وتقدير</span></h1>
<p style="text-align: center;"><span dir="rtl">شكر خاص لأختي سمر، وأخي زوجتي الأستاذ أحمد الأزهري على مساعدتي في المراجعة والتصحيح.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?488a06ce